import {Component} from 'react';
import h from 'react-hyperscript';
import './StickyElement.scss';

class StickyElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSticky: false,
      classes: 'sticky-element',
    };

    this.thresholdCounter = 0;
    this.previousScroll = 0;
    this.lastScrollDirection = 0;
    this.lastHeaderState = this.state.isSticky;
    this.threshold = 20;
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const currentScroll = window.scrollY;
    const scrollDirection = currentScroll < this.previousScroll ? -1 : 1;
    const trigger = this.props.offset;

    if (scrollDirection === this.lastScrollDirection) {
      this.thresholdCounter++;
    } else {
      this.thresholdCounter = 0;
    }

    if (currentScroll > trigger) {
      if (this.thresholdCounter >= this.threshold) {
        this.setIsSticky(true);
      }
    } else {
      this.setIsSticky(false);
    }

    this.previousScroll = currentScroll;
    this.lastScrollDirection = scrollDirection;
    this.lastHeaderState = this.state.isSticky;
  }

  setIsSticky(value) {
    if (this.state.isSticky !== value) {
      this.setState({
        isSticky: value,
      }, () => {
        if (this.state.isSticky) {
          this.setClasses('sticky-element is-sticky');
        } else {
          this.setClasses('sticky-element');
        }
      });
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  render() {
    return (
      h('div', {
        id: this.props.id,
        className: this.state.classes,
      }, this.props.children)
    );
  }
}

export default StickyElement;
